
import React from 'react';
import Icon from 'react-icon-base';

const DmiWarning = props => (
  <Icon viewBox="0 0 20 20" {...props}>
    <g>
      <g fill="none" fillRule="evenodd">
        <path d="M-2-2h24v24H-2z" />
        <path fill="currentColor" fillRule="nonzero" d="M10 20c5.52 0 10-4.48 10-10S15.52 0 10 0 0 4.48 0 10s4.48 10 10 10zM9 5h2v6H9V5zm0 8h2v2H9v-2z" />
      </g>
    </g>
  </Icon>
);

export default DmiWarning;
